import { BookingRequest, InvoiceResponse, PaymentStatus } from 'types';

// With `netlify dev` the app is served on :8888 together with the functions; opening the CRA dev server on :3000 directly still works.
const BASE = window.location.port === '3000' ? 'http://localhost:8888/.netlify/functions' : '/.netlify/functions';

async function post<T>(fn: string, body: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`${BASE}/${fn}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  } catch {
    throw new Error('Could not reach the server. Please check your connection and try again.');
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Something went wrong. Please try again.');
  return data;
}

export const createInvoice = (req: BookingRequest) => post<InvoiceResponse>('create-invoice', req);
export const confirmFree = (req: BookingRequest) => post<{ reservationId: string }>('confirm-free', req);
export const getPaymentStatus = (paymentIntentId: string) => post<PaymentStatus>('payment-status', { paymentIntentId });
